import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { useApi } from "@/lib/api";

const MeContext = createContext(null);

export const MeProvider = ({ children }) => {
  const { isSignedIn, isLoaded } = useAuth();
  const api = useApi();
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const refresh = useCallback(async () => {
    if (!isSignedIn) {
      setMe(null);
      setLoading(false);
      return;
    }
    try {
      setMe(await api("get", "/me"));
      setError(false);
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [api, isSignedIn]);

  useEffect(() => {
    if (isLoaded) {
      setLoading(true);
      refresh();
    }
  }, [isLoaded, refresh]);

  return <MeContext.Provider value={{ me, loading: loading || !isLoaded, error, refresh }}>{children}</MeContext.Provider>;
};

export const useMe = () => useContext(MeContext);
